import AxiosClient from "../AxiosClient";

export const getProductClassM = (params) => {
  const url = "/api/productClassM/searchInfoList";
  return AxiosClient.post(url, params);
};
